import { ChaptersNavigation, Position } from "_deziiign/books/core/components/chaptersNavigation/ChaptersNavigation";
import { FC, useMemo } from "react";
import { useSelector } from "react-redux";
import { useRouteMatch } from "react-router-dom";
import { isServer } from "shared/constants/isServer";
// import { isServer } from "shared/constants/isServer";
import { getChapter } from "shared/reducers/ChapterPagerSlice";
import { AppTester } from "supporting";

export const ChapterPager: FC = () => {
    const isProjectPreview = !!useRouteMatch("/preview");
    const isProjectInBookPreview = !!useRouteMatch(["/books/preview", "/book-preview"]);
    const isBookProjectPreview = !!useRouteMatch(["/books/book-preview", '/book-preview']);
    const isBooks = AppTester.isBooks();
    const {chapter} = useSelector(getChapter);
    const isProjectPage = !!useRouteMatch(['/project/:id', '/books/project/:id'])

    const isChapter = useMemo(() => {
        return chapter?.projectId && chapter?.book;
    } , [chapter])

    const isPreview = useMemo(
        () => isProjectPreview || isProjectInBookPreview
    , [isProjectPreview, isProjectInBookPreview]);
    
    if (isServer || !chapter || isPreview || !isBooks || isBookProjectPreview || !isChapter || !isProjectPage) {
        return null;
    }

    return (
        <ChaptersNavigation 
            currentChapter={chapter} 
            position={Position.top}
        />
    )
}import { ChaptersNavigation, Position } from "_deziiign/books/core/components/chaptersNavigation/ChaptersNavigation";
import { FC, useMemo } from "react";
import { useSelector } from "react-redux";
import { useRouteMatch } from "react-router-dom";
import { isServer } from "shared/constants/isServer";
// import { isServer } from "shared/constants/isServer";
import { getChapter } from "shared/reducers/ChapterPagerSlice";
import { AppTester } from "supporting";

export const ChapterPager: FC = () => {
    const isProjectPreview = !!useRouteMatch("/preview");
    const isProjectInBookPreview = !!useRouteMatch(["/books/preview", "/book-preview"]);
    const isBookProjectPreview = !!useRouteMatch(["/books/book-preview", '/book-preview']);
    const isBooks = AppTester.isBooks();
    const {chapter} = useSelector(getChapter);
    const isProjectPage = !!useRouteMatch(['/project/:id', '/books/project/:id'])

    const isChapter = useMemo(() => {
        return chapter?.projectId && chapter?.book;
    } , [chapter])

    const isPreview = useMemo(
        () => isProjectPreview || isProjectInBookPreview
    , [isProjectPreview, isProjectInBookPreview]);
    
    if (isServer || !chapter || isPreview || !isBooks || isBookProjectPreview || !isChapter || !isProjectPage) {
        return null;
    }

    return (
        <ChaptersNavigation 
            currentChapter={chapter} 
            position={Position.top}
        />
    )
}